import React from 'react';

type Props = {
    label?: string | false
}

export default function LayoutViewBusyLoading(props:Props) {

    const label = props.label || 'Please wait'

    const onOverlayClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        e.preventDefault()

        return
    }

    return (
        <div className="ui-view-loading view-busy-loading" onClick={onOverlayClick}>
            <div className="loading-block">
                <img className="loading-image" src={gdConfig.assetsPath + "/skin/common/loader/app-loading.gif?" + gdConfig.build} />
                <div className="loading-label">{label}</div>
            </div>
        </div>
    )
}
